import { Button } from '@/components/ui/button';
import { InputGroup, InputGroupInput } from '@/components/ui/input-group';
import { Label } from '@/components/ui/label';

type WebviewCustomUrlInputProps = {
	value: string;
	onChange: (value: string) => void;
	onPreview: () => void;
	disabled?: boolean;
};

export default function WebviewCustomUrlInput({ value, onChange, onPreview, disabled }: WebviewCustomUrlInputProps) {
	return (
		<div className='flex flex-col gap-2'>
			<div>
				<Label className='text-sm'>Ваша ссылка для WebView</Label>
				<p className='text-xs text-muted-foreground'>Например: example.com</p>
			</div>
			<div className='flex flex-col gap-2 sm:flex-row'>
				<InputGroup className='flex-1'>
					<InputGroupInput
						placeholder='https://example.com'
						disabled={disabled}
						value={value}
						onChange={e => onChange(e.target.value)}
					/>
				</InputGroup>
				<Button type='button' variant='secondary' disabled={disabled || !value.trim()} onClick={onPreview}>
					Показать превью
				</Button>
			</div>
		</div>
	);
}
